export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10">
            <div className="lg:w-[280px] flex-shrink-0">
              <div className="relative">
                <div className="absolute -inset-2 bg-primary-100/60 rounded-2xl blur-md"></div>
                <div className="relative w-48 h-48 md:w-56 md:h-56 mx-auto rounded-2xl overflow-hidden border border-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20cinematic%20streaming%20platform%20logo%20concept%20with%20film%20projector%20and%20play%20button%2C%20warm%20red%20and%20gold%20accents%20on%20dark%20background%2C%20clean%20minimal%20design%2C%20premium%20entertainment%20brand%20identity%2C%2080s%20nostalgic%20cinema%20vibe%20with%20modern%20aesthetic&width=600&height=600&seq=about-logo-2026&orientation=squarish"
                    alt="6080新视觉影视品牌标识"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-4">
                关于6080新视觉影视
              </h2>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
                6080新视觉影视是一个纯粹的免费在线影视平台，自创立以来始终秉持"免费、高清、流畅"的服务理念，
                为广大追剧爱好者提供一站式的观影体验。我们不设会员门槛、不收费、不插广告，只为让每一位用户
                都能轻松享受影视带来的快乐。
              </p>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
                平台涵盖电影、电视剧、综艺、动漫等多个分类，资源覆盖华语、韩剧、美剧、日剧等热门类型。
                每日同步更新，确保您不错过任何一集精彩内容。无需下载、无需注册，打开浏览器即可畅享高清画质。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <div className="flex items-center gap-2 text-sm text-foreground-500">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100">
                    <i className="ri-shield-check-line text-primary-500"></i>
                  </div>
                  <span>安全纯净无广告</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-500">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100">
                    <i className="ri-flashlight-line text-accent-500"></i>
                  </div>
                  <span>极速加载不卡顿</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-500">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100">
                    <i className="ri-device-line text-secondary-500"></i>
                  </div>
                  <span>多端适配随心看</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}